import { useState } from "react";

import { FlowError } from "@/errors/Flow-Error";
import { errorToast } from "@/lib/toast";

export const useStatus = (initalState = initialStatus) => {
  const [status, setStatus] = useState(initalState);

  const setToError = () => setStatus(errorStatus);
  const setToSuccess = () => setStatus(successStatus);
  const setToLoading = () => setStatus(loadingStatus);
  const resetStatus = () => setStatus(initalState);

  const errorHandler = async (callbackFn) => {
    setToLoading();
    try {
      const result = await callbackFn();
      setToSuccess();
      return result;
    } catch (err) {
      setToError();
      if (!(err instanceof FlowError)) {
        errorToast(err?.response?.data?.message);
        return console.log(err);
      }
      if (err.shouldAlert) return errorToast(err.description);
    }
  };

  return {
    status,
    setToError,
    setToLoading,
    setToSuccess,
    resetStatus,
    errorHandler,
  };
};

const initialStatus = {
  loading: false,
  error: false,
  success: false,
};

const successStatus = {
  loading: false,
  error: false,
  success: true,
};

const loadingStatus = {
  loading: true,
  error: false,
  success: false,
};

const errorStatus = {
  loading: false,
  error: true,
  success: false,
};
